import React, { Component } from "react";
import { Accordion } from "semantic-ui-react";
import _ from "lodash";

class SocialMediaSection extends Component {
  constructor(props) {
    super(props);
    const additionalData = _.cloneDeep(this.props.additionalData);
    additionalData.requestedSection = "media";
    this.state = {
      activeIndex: 0,
    };
  }

  componentDidMount() {
    this.props.updateItemCountBySection(this.props.sectionName, 0);
  }

  handleClick = () => {
    if (this.state.activeIndex === 0) {
      this.setState({ activeIndex: -1 });
    } else {
      this.setState({ activeIndex: 0 });
    }
  };

  render() {
    return (
      <Accordion fluid styled>
        <Accordion.Title
          className="report-section-header"
          active={this.state.activeIndex === 0}
          key={`ComTitle`}
          onClick={() => this.handleClick()}
        >
          <p>
            Social Media
            <span className={"icon-toggle-accordion"}>
              {this.state.activeIndex === 0 ? "-" : "+"}
            </span>
          </p>
        </Accordion.Title>
        <Accordion.Content
          key={`ComBody`}
          active={this.state.activeIndex === 0}
        >
          No Records Found
        </Accordion.Content>
      </Accordion>
    );
  }
}

export default SocialMediaSection;



// WEBPACK FOOTER //
// ./src/components/reports/SocialMediaSection.js